import React from 'react';
import { Checkbox } from 'antd'
function Checkboxs(props) {
  return <Checkbox
    onChange={props.evt}
    checked={props.checked}
    value={props.value}>
    {props.label}
  </Checkbox>
}

export default Checkboxs;